import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ManageUserEntryPage } from '../../components/ManageUserEntryPage';
export const Main = () => {
  return (
    <Switch>
      <Route path='/users/entry' component={ManageUserEntryPage} exact={true} />
      <Route
        path='/users/entry/:id'
        component={ManageUserEntryPage}
        exact={true}
      />
    </Switch>
  );
};
